<template>
  <qx-card-form title="收款信息">
    <qx-custom-form
      :noSubBtn="true"
      ref="baseForm"
      :formData="baseForm"
      labelWidth="120px"
    >
      <section slot="receiver" slot-scope="prop">
        <ChooseReceiver
          :disabled="isOil"
          :isRadio="true"
          v-model="prop.form.receiver"
          @change="handleReceiverChange"
        />
      </section>
      <section slot="selectedLIds" slot-scope="prop">
        <ChooseDeduct :acUserId="acUserId" v-model="prop.form.selectedLIds" @change="handleDeductChange" />
      </section>
    </qx-custom-form>
  </qx-card-form>
</template>

<script>
import {
  deductList,
  manageRechargeReceiptAccount,
} from 'api/cost';
import ChooseReceiver from 'components/choose/receiver';
import ChooseDeduct from 'components/chooseDeduct/chooseDeduct';
export default {
  components: {
    ChooseReceiver,
    ChooseDeduct,
  },
  data () {
    return {
      isOil: false,
      acUserId: '',
      otherFormData: {
        deductAmount: '', // 抵扣金额
      },
      baseForm: {
        orgIdOptions: [],
        form: [
          {
            label: '收款人',
            value: 'receiver',
            default: {},
            slot: true,
            disabled: false,
          },
          {
            label: '收款账户名',
            value: 'receUserName',
            type: 'input',
            disabled: true,
          },
          {
            label: '收款银行',
            value: 'receBankName',
            type: 'input',
            disabled: true,
          },
          {
            label: '收款账号',
            value: 'receBankNo',
            type: 'input',
            disabled: true,
          },
          {
            label: '抵扣借支',
            value: 'selectedLIds',
            slot: true,
            hide: false,
            default: [],
          },
          {
            label: '应付金额',
            value: 'shouldPayAmount',
            type: 'input',
            disabled: true,
          },
        ],
        rules: {
          receiver: [ // 收款人
            { required: true, message: '请选择收款人', trigger: 'blur' },
          ],
        },
      },
    };
  },
  methods: {
    async getRechargeAccount () {
      const res = await manageRechargeReceiptAccount({
        oilRechargeType: 2,
      });
      const receivedBankInfo = res.receivedBankInfo;
      this.$refs.baseForm.setVal('receiver', {
        userId: receivedBankInfo.userId,
        receiverName: res.serviceName,
        acctNo: receivedBankInfo.acctNo,
        acctName: receivedBankInfo.acctName,
        bankName: receivedBankInfo.bankName,
        pinganCollectAcctId: receivedBankInfo.pinganCollectAcctId,
        userType: receivedBankInfo.userType || 2,
        balanceType: receivedBankInfo.bankType,
        // expireDate: receivedBankInfo.acctNo,
      });
      this.handleReceiverChange();
    },

    handleReceiverChange () { // 收款人变化
      const receiver = this.$refs.baseForm.getVal('receiver');
      this.acUserId = String(receiver.userId);
      this.$refs.baseForm.setVal('receUserName', receiver.receiverName);
      this.$refs.baseForm.setVal('receBankName', receiver.bankName);
      this.$refs.baseForm.setVal('receBankNo', receiver.acctNo);
      this.$refs.baseForm.setVal('selectedLIds', []);
    },

    handleDeductChange () { // 抵扣变化
      this.$emit('getOtherFormVal', {
        from: 'receipt',
        tar: 'baseForm',
      });
    },
    receiveData (tar, val) {
      const payAmt = val.payAmt;
      const selectedLIds = this.$refs.baseForm.getVal('selectedLIds');
      if (payAmt > 0 && selectedLIds && selectedLIds.length > 0) {
        const deductAmount = selectedLIds.reduce((last, next) => ({amount: last.amount + next.amount}), {amount: 0});
        this.otherFormData.deductAmount = deductAmount.amount; // 抵扣金额
        this.$refs.baseForm.setVal('shouldPayAmount', payAmt - deductAmount.amount);
      }
      // 找油账户
      if (val.payType === 4308) {
        this.getRechargeAccount();
      }
      this.isOil = val.payType === 4308;
      this.setFormAttrVal({
        form: this.baseForm,
        attr: 'hide',
        value: val.payType === 4308,
        names: ['selectedLIds'],
      });
    },

    async handleSubData (cache) {
      let formData;
      if (cache) {
        formData = await this.$refs.baseForm.getVal();
      } else {
        formData = await this.$refs.baseForm.sub();
      }
      if (formData || cache) {
        if (formData.receiver) {
          formData.receName = formData.receiver.receiverName; // 收款方名称
          formData.receUserName = formData.receiver.acctName; // 收款账户名
          formData.receBankName = formData.receiver.bankName; // 收款方银行
          formData.receBankNo = formData.receiver.acctNo; // 收款方银行卡号
          formData.receAccNo = formData.receiver.pinganCollectAcctId; // 收款方账户
          formData.receUserType = formData.receiver.userType; // 收款方类型
          formData.receUserId = formData.receiver.userId; // 收款方ID
          formData.balanceType = formData.receiver.balanceType; // 结算方式
          formData.expireDate = this.formatDate(formData.receiver.expireDate || new Date()); // 到期时间
          delete formData.receiver;
        }
        formData.userType = formData.receUserType;
        formData.deductAmount = this.otherFormData.deductAmount;
      }
      return formData;
    },

    async sub () {
      const formData = await this.handleSubData(true);
      if (formData) {
        formData.selectedLIds = JSON.stringify(formData.selectedLIds.map((item) => ({
          LId: item.LId,
          deductAmount: item.amount,
        })));
      }
      return formData;
    },
    async cacheData () {
      const res = await this.handleSubData();
      if (res.selectedLIds) {
        res.selectedLIds = res.selectedLIds.map((item) => item.LId);
        res.selectedLIds = res.selectedLIds.join(',');
      }
      return res;
    },
    async init (data = {}) {
      if (data.receName) {
        data.receiver = {
          receiverName: data.receName, // 收款方名称
          acctName: data.receUserName, // 收款账户名
          bankName: data.receBankName, // 收款方银行
          acctNo: data.receBankNo, // 收款方银行卡号
          pinganCollectAcctId: data.receAccNo, // 收款方账户
          userType: data.receUserType, // 收款方类型
          userId: String(data.receUserId), // 收款方ID
          balanceType: data.balanceType, // 结算方式
        };
      } else {
        data.receiver = {};
      }
      this.acUserId = String(data.receUserId); // 收款人id
      if (data.selectedLIds) {
        const LIds = data.selectedLIds.split(',');
        const amounts = [];
        const amountRes = await deductList({
          acUserId: this.acUserId,
          relBusiCode: data.busiCode,
        });
        amountRes.items.forEach((item) => {
          if (LIds.indexOf(String(item.LId)) !== -1) {
            amounts.push(item.amount);
          }
        });
        data.selectedLIds = LIds.map((LId, index) => ({
          LId,
          amount: amounts[index],
        }));
      } else {
        data.selectedLIds = [];
      }
      this.$refs.baseForm.setVal('form', data);
      this.setFormVal(this.otherFormData, data);
      this.setFormAttrVal({
        form: this.baseForm,
        attr: 'hide',
        value: Boolean(this.$route.query.id),
        names: ['selectedLIds', 'shouldPayAmount'],
      });
    },
  },
};
</script>

<style scoped lang="scss">
</style>
